import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/videoBJ.png'


_pushScopeId("data-v-9b1b0818")
const _hoisted_1 = { class: "courseware-preview" }
const _hoisted_2 = {
  key: 0,
  class: "courseware-preview-audio"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "image-placeholder" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 加载中... ")
const _hoisted_6 = {
  key: 2,
  class: "courseware-preview-video"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 3,
  class: "courseware-preview-sing-play"
}
_popScopeId()

import { computed, ref, watchEffect } from "vue";
import { Picture as IconPicture } from "@element-plus/icons-vue";
import VideoControl from "@/components/VideoControl.vue";
import CustomPPTNext from "@/components/CustomPPTNext.vue";
import SingPlay from "./SingPlay.vue";
import { ElMessage } from "element-plus";
import { startFlashPlayer } from "@/electronService";
import store from "@/store";


export default _defineComponent({
  setup(__props, { expose }) {

const audioVisible = ref(false);
const imageVisible = ref(false);
const videoVisible = ref(false);
const pptVisible = ref(false);
const singPlayVisible = ref(false);

const visible = computed(() => {
  return (
    audioVisible.value ||
    imageVisible.value ||
    videoVisible.value ||
    pptVisible.value ||
    singPlayVisible.value
  );
});

const reset = () => {
  if (pptVisible.value && customPPTRef.value) {
    customPPTRef.value.reset();
  }
  audioVisible.value = false;
  imageVisible.value = false;
  videoVisible.value = false;
  pptVisible.value = false;
  singPlayVisible.value = false;
  singPlayProps.value = undefined;
  pptUrl.value = "";
  coursewareUrl.value = "";
  status.value = "stop";
  duration.value = 1;
  currentTime.value = 0;
};

const audioRef = ref<HTMLAudioElement>();
const videoRef = ref<HTMLVideoElement>();
const coursewareUrl = ref("");
const customPPTRef = ref();
const pptUrl = ref("");
const singPlayProps = ref<any>();

const videoControlRef = ref();
const status = ref<any>("stop");
const duration = ref(1);
const currentTime = ref(0);

// 视频播放逻辑
const onPlay = (_status: string) => {
  const player = videoRef.value;
  if (!player) {
    return;
  }
  if (_status === "play") {
    player.play();
  } else {
    player.pause();
  }
  status.value = _status;
};
const onStop = () => {
  const player = videoRef.value;
  status.value = "stop";
  if (!player) {
    return;
  }
  player.currentTime = 0;
  player.pause();
};

const onSetTime = (currentTime: number) => {
  const player = videoRef.value;
  if (!player) {
    return;
  }
  player.currentTime = currentTime;
};

const init = () => {
  const player = videoRef.value;
  player &&
    player.addEventListener("durationchange", () => {
      duration.value = player.duration;
    });

  player &&
    player.addEventListener("timeupdate", () => {
      currentTime.value = player.currentTime;
    });
};

watchEffect(init);

// 检查是否有flash播放器事件支持
const checkHasFlashPlayer = () => {
  const list = store.state.registedEvents || [];
  try {
    // windows
    if ((list as any).indexOf("start-flash-player") > -1) {
      return true;
    }
  } catch (error) {
    return false;
  }

  return false;
};

const showCourseWare = (type: string, url: string, props?: any) => {
  reset();
  switch (type) {
    case "audio":
      audioVisible.value = true;
      break;
    case "image":
      imageVisible.value = true;
      break;
    case "video":
      videoVisible.value = true;
      break;
    case "ppt":
      pptVisible.value = true;
      pptUrl.value = url;
      break;
    case "swf": {
      if (checkHasFlashPlayer() == false) {
        ElMessage.error({
          offset: 200,
          message: "该系统版本暂不支持预览本类型，请升级系统",
          type: "error",
        });
        return;
      }
      try {
        startFlashPlayer({ url });
      } catch (err) {
        console.error(err);
        ElMessage.error({
          offset: 200,
          message: "打开课件异常，请重试",
          type: "error",
        });
      }
      break;
    }
    case "sheet_song": {
      singPlayVisible.value = true;
      singPlayProps.value = props;
      break;
    }
    default:
      break;
  }
  coursewareUrl.value = url;
  setTimeout(() => {
    audioRef.value && audioRef.value?.play();
    videoRef.value && videoControlRef.value && videoControlRef.value?.play();
  }, 100);
};

expose({ visible, showCourseWare, reset });

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (audioVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("audio", {
            ref: audioRef,
            controls: "",
            src: coursewareUrl.value,
            controlsList: "nodownload",
            oncontextmenu: "return false"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "close",
            onClick: reset
          })
        ]))
      : _createCommentVNode("", true),
    (imageVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "courseware-preview-image",
          onClick: reset
        }, [
          _createVNode(_component_el_image, {
            src: coursewareUrl.value,
            fit: "scale-down",
            style: {"width":"90%","height":"90%"}
          }, {
            placeholder: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconPicture))
                  ]),
                  _: 1
                }),
                _hoisted_5
              ])
            ]),
            _: 1
          }, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    (videoVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("video", {
            ref: videoRef,
            src: coursewareUrl.value,
            crossorigin: "anonymous",
            oncontextmenu: "return false",
            disablePictureInPicture: "true",
            poster: _imports_0
          }, null, 8, _hoisted_7),
          _createVNode(VideoControl, {
            ref: videoControlRef,
            status: status.value,
            duration: duration.value,
            currentTime: currentTime.value,
            onPlay: onPlay,
            onStop: onStop,
            onSetTime: onSetTime
          }, null, 8, ["status", "duration", "currentTime"]),
          _createElementVNode("div", {
            class: "close",
            onClick: reset
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(
        pptVisible.value ? 'courseware-preview-ppt' : 'courseware-preview-ppt-hide'
      )
    }, [
      _createVNode(CustomPPTNext, {
        url: pptUrl.value,
        onGoBack: reset,
        ref: customPPTRef
      }, null, 8, ["url"])
    ], 2),
    (singPlayVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(SingPlay, {
            data: singPlayProps.value,
            onGoBack: reset
          }, null, 8, ["data"])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _unref(visible)]
  ])
}
}

})